// @flow

import { alfredUrl, defaultDomain, subDomain } from '../config'

export default {
  buildAlfredUrl: function (path: ?string, withCallBackUrl: boolean = true, hasPassword: boolean = true) {
    let url = alfredUrl
    if (path) url = `${alfredUrl}/${path}`
    let callbackUrl = ''
    if (withCallBackUrl) callbackUrl = `&callbackUrl=https://${subDomain}.${defaultDomain}`
    let routeToAlfredUrl = `${url}?subdomain=${subDomain}${callbackUrl}`
    if (!hasPassword) routeToAlfredUrl += '&hasPassword=false'
    return routeToAlfredUrl
  }
}
